import { useEffect, useState } from "react";
import { getWebsiteSettings } from "@/services/settings.service";

/**
 * Live website settings (settings/website) for public components.
 *
 * Safe to call from several components at once: the settings service caches the
 * in-flight promise, so the header, footer and favicon share a single read
 * rather than each issuing their own.
 */
export default function useWebsiteSettings() {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        let cancelled = false;
        getWebsiteSettings()
            .then((value) => {
                if (!cancelled) setSettings(value);
            })
            .catch((err) => {
                // Branding is decorative; every consumer falls back to a
                // compiled-in default rather than rendering nothing.
                console.warn("[settings] could not load website settings:", err.message);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return settings;
}
